import {createAction} from 'Shared/utilities/actionCreator';

export enum TokenRefreshActionTypes {
  TOGGLE_LOGIN_SPINNER = 'token/TOGGLE_LOGIN_SPINNER',
  WAS_FORCE_LOG_OUT = 'token/WAS_FORCE_LOG_OUT',
}

export const toggleLoginSpinner = (isOpen: boolean) => {
  return createAction(TokenRefreshActionTypes.TOGGLE_LOGIN_SPINNER, {isOpen});
};

export const isForceLogout = (isForceLogout: boolean) => {
  return createAction(TokenRefreshActionTypes.WAS_FORCE_LOG_OUT, {isForceLogout});
};

type LoginState = {
  isOpen: boolean;
  wasForceLoggedOut: boolean;
};

export const DEFAULT_STATE: LoginState = {
  isOpen: false,
  wasForceLoggedOut: false,
};

type TokenAction = ReturnType<typeof toggleLoginSpinner> | ReturnType<typeof isForceLogout>;

export default (state: LoginState = DEFAULT_STATE, action: TokenAction): LoginState => {
  switch (action.type) {
    case TokenRefreshActionTypes.TOGGLE_LOGIN_SPINNER:
      return {
        ...state,
        isOpen: action.payload.isOpen,
      };
    case TokenRefreshActionTypes.WAS_FORCE_LOG_OUT:
      return {
        ...state,
        wasForceLoggedOut: action.payload.isForceLogout,
      };
    default:
      return state;
  }
};
